import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/statistics',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/statistics',
      name: 'statistics',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/Statistics.vue')
    }

  ]
};
export default app;
